<template>
  <div class="login-page">
    <!-- 背景图片 -->
    <!-- <background-image></background-image> -->
    <!-- 登录面板 -->
    <div class="login-body">
      <!-- logo图片 -->
      <!-- <logo-image></logo-image> -->
      <div class="logo_big">
        <img class="logo-image" src="../assets/img/shiji-logo-v2.png" />
      </div>
      <div class="logo_small">
        <img class="logo-image" src="../assets/img/shiji-logo-white.png" />
      </div>
      <div
        v-show="!showErrorMessage"
        class="notification-container notification-error"
      >
        <div class="alert alert-danger" v-show="showError">
          <svg
            t="1642388674564"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="6650"
            width="15"
            height="15"
          >
            <path
              d="M512 0C229.23 0 0 229.23 0 512s229.23 512 512 512c282.768 0 512-229.23 512-512C1024 229.23 794.77 0 512 0zM746.76 656.252c7.808 7.808 7.806 20.472 0.002 28.284l-62.228 62.224c-7.808 7.808-20.47 7.814-28.286 0.002L512 602.51l-144.25 144.25c-7.81 7.812-20.474 7.808-28.284 0l-62.226-62.224c-7.81-7.808-7.812-20.472 0-28.284L421.492 512l-144.25-144.25c-7.81-7.808-7.81-20.474 0-28.284l62.226-62.224c7.81-7.812 20.474-7.81 28.284 0L512 421.49l144.252-144.25c7.806-7.812 20.47-7.81 28.282 0l62.226 62.224c7.806 7.812 7.808 20.474 0 28.284L602.51 512 746.76 656.252z"
              p-id="6651"
              fill="#FF0000"
            ></path>
          </svg>

          <div class="notification-content" v-html="showErrorMSg"></div>
        </div>
      </div>
      <!-- 登录用户名显示 -->
      <div>
        <p v-if="currentLocale == 'zh'">
          <span>当前登录用户：</span
          ><span style="color: brown">{{
            decodeURIComponent(loginInfo.loginName)
          }}</span>
        </p>
        <p v-else>
          <span> Current Logged In User：</span
          ><span style="color: brown">{{
            decodeURIComponent(loginInfo.loginName)
          }}</span>
        </p>
      </div>
      <div style="display: flex; margin-top: 20%">
        <div style="width: 120px; margin-right: 30px">
          <button
            ref="button"
            type="submit"
            class="loginButton"
            @click="goToLogin"
            v-if="currentLocale == 'zh'"
          >
            去学习
          </button>
          <button
            ref="button"
            type="submit"
            class="loginButton"
            @click="goToLogin"
            v-else
          >
            Go Learn
          </button>
        </div>
        <div style="width: 120px">
          <button
            ref="button"
            type="submit"
            class="loginButton"
            @click="switchUser"
            v-if="currentLocale == 'zh'"
          >
            切换用户
          </button>
          <button
            ref="button"
            type="submit"
            class="loginButton"
            @click="switchUser"
            v-else
          >
            Switch User
          </button>
        </div>
      </div>

      <!-- 登录成功后的提示 -->
      <!-- <h1 class="succeeded" v-if="succeeded">Login succeeded</h1> -->
      <!-- <div v-else>
        登录文字
        <h1 class="login-h1">Log In Using Default Account</h1>
        登录报错提示
        <div class="notification-container notification-error">
          <div class="alert alert-danger" v-show="showError">
            <svg
              t="1642388674564"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="6650"
              width="15"
              height="15"
            >
              <path
                d="M512 0C229.23 0 0 229.23 0 512s229.23 512 512 512c282.768 0 512-229.23 512-512C1024 229.23 794.77 0 512 0zM746.76 656.252c7.808 7.808 7.806 20.472 0.002 28.284l-62.228 62.224c-7.808 7.808-20.47 7.814-28.286 0.002L512 602.51l-144.25 144.25c-7.81 7.812-20.474 7.808-28.284 0l-62.226-62.224c-7.81-7.808-7.812-20.472 0-28.284L421.492 512l-144.25-144.25c-7.81-7.808-7.81-20.474 0-28.284l62.226-62.224c7.81-7.812 20.474-7.81 28.284 0L512 421.49l144.252-144.25c7.806-7.812 20.47-7.81 28.282 0l62.226 62.224c7.806 7.812 7.808 20.474 0 28.284L602.51 512 746.76 656.252z"
                p-id="6651"
                fill="#FF0000"
              ></path>
            </svg>

            <div class="notification-content" v-html="showErrorMSg"></div>
          </div>
        </div>
        登录表单
        <div>
          <el-form ref="form" :model="form">
            用户名
            <div class="ac-field">
              <label class="label-size">{{
                $t("lang.SIGNIN.label_username")
              }}</label>
              <el-input
                required
                ref="userName"
                size="small"
                v-model="form.userName"
                placeholder="Fill"
                autocomplete="off"
              ></el-input>
            </div>
            密码
            <div class="ac-field">
              <label class="label-size">{{
                $t("lang.SIGNIN.label_password")
              }}</label>
              <el-input
                required
                ref="passWord"
                size="small"
                v-model="form.passWord"
                placeholder="Fill"
                autocomplete="off"
                show-password
              ></el-input>
            </div>
            <div class="margin-bottom">
              <el-checkbox size="medium" v-model="rememberPassword"
                >Remember Password</el-checkbox
              >
            </div>
            按钮
            <div>
              <button
                ref="button"
                type="submit"
                class="loginButton"
                @click="login"
              >
                Login
              </button>
            </div>
          </el-form>
          返回登录
          <div class="distance-button">
            <div class="distance-Log">
              <div>
                <router-link class="a-style" replace to="/acNormalLogin">
                  Log In Using Normal Account
                </router-link>
              </div>
              <router-link class="a-style" replace to="/sepLogin">
                Log In Using SEP Account
              </router-link>
              <div class="a-style sis-style" @click="gotoSIS">
                Log In Using SIS Account
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- 登录脚部 -->
      <!-- <div class="distance-button">
        <div class="distance-Log">
          <div>
            <router-link class="a-style" replace to="/acNormalLogin">
              Log In Using Normal Account
            </router-link>
          </div>
          <router-link class="a-style" replace to="/sepLogin">
            Log In Using SEP Account
          </router-link>
          <div class="a-style sis-style" @click="gotoSIS">
            Log In Using SIS Account
          </div>
        </div>
      </div> -->
      <feet></feet>
    </div>
    <!-- 加载动画 -->
    <Spinner v-show="isLoading" />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import Spinner from "../components/Spinner.vue";
import backgroundImage from "../components/backGroundImage.vue";
import logoImage from "../components/logoImage.vue";
import feet from "../components/Feet.vue";
import {
  LOGIN_API,
  SIS_TOKEN_API,
  NORMAL_IDENTITY_TITLE,
  IDENTITY_ADDRESS,
  SEP_IDENTITY_TITLE,
  USER_TYPE_API,
} from "../../config-json.js";
const NORMAL_API = `${LOGIN_API}`;
const SIS_API = `${SIS_TOKEN_API}`;

export default {
  name: "Reset",
  components: {
    // logoImage,
    feet,
    Spinner,
  },
  data() {
    return {
      showErrorMSg: "",
      showError: false,
      succeeded: false,
      isLoading: false,
      rememberPassword: false,
      ReturnUrl: "",
      form: {
        userName: "",
        passWord: "",
      },
      returnParameter: "", // return后面带的参数
      realmNameUrl: "", // 网站的域名
      sisFlagLogin: false,
      sisCode: "",
      currentLocale: this.$cookies.get(SEP_IDENTITY_TITLE + "-" + "locale")
        ? this.$cookies.get(SEP_IDENTITY_TITLE + "-" + "locale")
        : "zh",
      loginInfo: this.$cookies.get(
        SEP_IDENTITY_TITLE + "-" + "SEP_access_token"
      ),
      showErrorMessage: false,
    };
  },
  created() {
    this.$i18n.locale = this.currentLocale;
  },
  methods: {
    goToLogin() {
      let webUrl = "https://op-web-cn1.shijicloud.com"; //https://op-web-cn1.shijicloud.com
      let SPMSUrl = "https://elearning.shijicloud.com/login/external?token";
      this.isLoading = true;
      // this.succeeded = true;
      // 获取token
      let tokenVal = this.$cookies.get(
        SEP_IDENTITY_TITLE + "-" + "SEP_access_token"
      );
      if (!tokenVal) {
        this.switchUser();
        return;
      }
      // 勾选管理平台登录 跳转自己的web端
      if (tokenVal.spmsCheck) {
        window.location =
          webUrl + "?access_token=" + encodeURIComponent(tokenVal.access_token);
      } else {
        let config = {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${tokenVal.access_token}`,
          },
        };
        // 换取管理平台token
        this.$httpServiceSEP({
          url: `${USER_TYPE_API}elearning/external/token`,
          config: config,
          method: "GET",
        })
          .then((res) => {
            // 跳转管理平台
            window.location = SPMSUrl + "=" + encodeURIComponent(res);
          })
          .catch((err) => {
            console.log("查看err--->", err);
            let error = this.handleError(this, err);
            console.log(`==error===`, error);
            this.showError = error.showError;
            this.showErrorMSg = error.errMsg;
            this.isLoading = false;
            console.log("登录失败---->>>", err);
            if (this.showErrorMessage) {
              this.$notify.error({
                title: "登录失败",
              });
            }
          });
      }
    },

    switchUser() {
      this.$cookies.remove(SEP_IDENTITY_TITLE + "-" + "SEP_access_token");
      this.$router.replace("/login");
    },
  },
};
</script>

<style scoped>
.sis-style {
  cursor: pointer;
}
@media (max-width: 768px) {
  .login-page {
    background: url("../assets/img/applet.jpg") no-repeat;
    background-position: center;
    height: 100%;
    width: 100%;
    background-size: cover;
    position: fixed;
  }
  .login-h1 {
    font-size: 24px;
    font-weight: 400;
    margin-bottom: 8px;
    color: #ffff;
  }
  .label-size {
    display: inline-block;
    order: 0;
    margin: 4px 0;
    font-size: 13px;
    line-height: 1.27;
    color: #ffff;
  }
  .el-checkbox {
    display: inline-block;
    padding-left: 10px;
    line-height: 19px;
    font-size: 14px;
    color: #ffff !important;
  }
  .ac-field {
    padding: 5px 0;
    flex-direction: column;
    text-align: left;
  }
  .logo_big {
    display: none;
  }
  .logo_small {
    width: 84px;
    height: 44px;
    box-sizing: border-box;
    margin-bottom: 16px;
  }
}
@media (min-width: 768px) {
  .logo_small {
    display: none;
  }
  .logo_big {
    width: 84px;
    height: 44px;
    box-sizing: border-box;
    margin-bottom: 16px;
  }
  .login-page {
    background: url("../assets/img/web.jpg") no-repeat;
    background-position: center;
    height: 100%;
    width: 100%;
    background-size: cover;
    position: fixed;
  }
  .login-page .login-body {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 490px;
    height: auto;
    min-height: 660px;
    max-height: 95vh;
    transform: translate(-50%, -50%);
    overflow-y: auto;
    padding: 40px 48px;
    box-shadow: 0 1px 4px rgb(0 0 0 / 50%);
  }
}
.enter-login {
  font-size: 13px;
  font-weight: 400;
}
.login-footer {
  margin-top: 150px;
  border-top: 2px solid #bdbdbd;
}
.succeeded {
  font-size: 27px;
  font-weight: 400;
  margin-bottom: 200px;
}
</style>
